import { GridRowModesModel, GridRenderCellParams } from '@mui/x-data-grid-pro';
import Button from '@mui/material/Button';
import { ModalProcedureFieldRuleParamsState } from './ModalProcedureFieldRuleParams';
import IconButton from '@mui/material/IconButton';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { Stack } from '@mui/material';
import { SubjectProcedureFieldRowItem } from 'types/api/SystemTenant/AROKMS/SubjectProcedureTypes';
import { RULES_CONSTANT } from 'constant/RuleConstant';

interface ProcedureFieldParamsActionButtonProps extends GridRenderCellParams<SubjectProcedureFieldRowItem> {
  setRowModesModel: (newModel: (oldModel: GridRowModesModel) => GridRowModesModel) => void;
  fieldName: 'ruleTypeParams' | 'consolidateRuleParams' | null;
  setModalParameterState: (
    newState: (OldState: ModalProcedureFieldRuleParamsState) => ModalProcedureFieldRuleParamsState
  ) => void;
  disabled?: boolean;
}

export function ProcedureFieldParamsActionButton(props: ProcedureFieldParamsActionButtonProps) {
  const { hasFocus, row, setModalParameterState, fieldName, disabled = false } = props;

  if (!fieldName || row?.isNew) return <span></span>;

  const handleOnClick = () => {
    if (fieldName) {
      setModalParameterState((prevState) => ({
        ...prevState,
        open: true,
        ruleTypeCode: row.ruleTypeProcedure?.value,
        initialValue: row.ruleTypeParams,
        tableDefinitionId: row.tableDefinition.value,
        fieldName: row.tableDefinition.label,
      }));
    }
  };

  if (!row.ruleTypeProcedure) {
    return <span></span>;
  }

  if (row.ruleTypeParams) {
    return (
      <Stack direction='row' alignItems='center'>
        <IconButton onClick={handleOnClick} aria-label='delete' size='small' disabled={disabled}>
          <ModeEditOutlineOutlinedIcon fontSize='inherit' />
        </IconButton>
        {row?.ruleTypeProcedure?.value === RULES_CONSTANT.TEXT.RULE_SELECT_FROM_KTREE_TABLE
          ? row?.ruleTypeParams?.ktreeDefinition?.label
          : row?.ruleTypeParams?.parameter}
      </Stack>
    );
  }

  return (
    <Button
      variant='secondary-table-panel'
      sx={{
        height: '58%',
        fontSize: '12px',
      }}
      onClick={handleOnClick}
      tabIndex={hasFocus ? 0 : -1}
      disabled={disabled}
      onKeyDown={(event: React.KeyboardEvent) => {
        if (event.key === ' ') {
          // Prevent key navigation when focus is on button
          event.stopPropagation();
        }
      }}
    >
      Add
    </Button>
  );
}
